import React from "react";
import { NavbarAdmin } from "../../../components";
import { Button } from "@/components/ui/button";


export const AdminLayout = (props) => {
  if (props.loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen bg-gray-50 dark:bg-gray-900">
      <NavbarAdmin />

      <div className="flex-1 md:pl-64 flex flex-col min-h-screen transition-all duration-300 ease-in-out">
        <header className="sticky top-0 z-30 flex items-center justify-between px-6 py-4 bg-white/80 dark:bg-gray-800/80 backdrop-blur-md border-b border-gray-200 dark:border-gray-700 shadow-sm">
          <div className="flex-1 min-w-0 ml-10 md:ml-0">
            <h1 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-gray-50">
              {props.title}
            </h1>
            {props.description && (
              <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                {props.description}
              </p>
            )}
          </div>
          <div className="flex items-center space-x-3">
            {props.actions?.map((item, index) => (
              <Button
                key={index}
                onClick={item.onClick}
                variant={item.variant || "default"}
                size={item.size || "default"}
                className={item.className}
              >
                {item.icon && <span className="mr-2">{item.icon}</span>}
                {item.name}
              </Button>
            ))}
          </div>
        </header>

        <main className="flex-1 p-6 overflow-x-hidden">
          <div className="mx-auto max-w-7xl space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
            {props.children}
          </div>
        </main>
      </div>
    </div>
  );
};